<section class="frosty-dialog-shell rounded-md border border-white/60 bg-white/70 p-4 backdrop-blur-xl">
    <header
        *ngIf="eyebrow || title || description"
        class="frosty-dialog-shell__header flex items-start justify-between gap-4">
        <div class="min-w-0">
            <span *ngIf="eyebrow" class="block text-xs font-semibold uppercase tracking-wide text-slate-500">
                {{ eyebrow }}
            </span>
            <h2 *ngIf="title" class="m-0 text-xl font-semibold text-slate-950">
                {{ title }}
            </h2>
            <p *ngIf="description" class="mt-1 text-sm leading-relaxed text-slate-600">
                {{ description }}
            </p>
        </div>

        <ng-content select="[dialog-actions]"></ng-content>
    </header>

    <div class="frosty-dialog-shell__body min-h-0 overflow-y-auto pr-1" [ngClass]="bodyClass">
        <ng-content></ng-content>
    </div>

    <footer class="frosty-dialog-shell__footer">
        <ng-content select="[dialog-footer]"></ng-content>
    </footer>
</section>
